// https://blog.zairza.in/vue-js-role-based-access-control-with-casl-library-822fd884d557

/* eslint-disable */

import { AbilityBuilder } from '@casl/ability';
import _ from 'lodash';
import { canUseConversations } from '../utils/siteCapability';

var user = JSON.parse(localStorage.getItem('user'));
//var settings = JSON.parse(localStorage.getItem('settings'));

// Features that may be overridden by FEATURE_PERMISSIONS. Conditional rules
// like Wiki Pages (`can(['edit','delete'], 'Page', { CreatedByEmployeeID })`)
// are intentionally excluded — overrides only target the simple action set.
const OVERRIDABLE_FEATURES = new Set([
    'team-insights', 'huddle', 'kanban', 'tasks', 'chat', 'sms-conversations',
    'conversations', 'wiki', 'forms', 'asap_list', 'overdue_recall',
    'unscheduled_treatment', 'outstanding_claim', 'broken_appointment',
    'patient_balances', 'outstanding_preauths', 'settings', 'kpi',
    'practice-pulse', 'workflow', 'myaccount', 'employee', 'chatroom',
    'followupDate', 'followupNote', 'campaigns', 'insurance-verification',
]);

const VIEW_ACTIONS = ['view', 'read'];
const UPDATE_ACTIONS = ['update', 'edit', 'add'];
const DELETE_ACTIONS = ['delete'];
const ALL_ACTIONS = [...VIEW_ACTIONS, ...UPDATE_ACTIONS, ...DELETE_ACTIONS];

function applyLevel(can, cannot, level, feature) {
    switch (level) {
        case 'None':
            cannot(ALL_ACTIONS, feature);
            return;
        case 'Read':
            can(VIEW_ACTIONS, feature);
            cannot([...UPDATE_ACTIONS, ...DELETE_ACTIONS], feature);
            return;
        case 'Update':
            can([...VIEW_ACTIONS, ...UPDATE_ACTIONS], feature);
            cannot(DELETE_ACTIONS, feature);
            return;
        case 'Delete':
            can(ALL_ACTIONS, feature);
            return;
        default:
            return;
    }
}

function applyFeaturePermissionOverrides(can, cannot, user, _settings) {
    if (!user || !user.Role) return;
    if (user.Role === 'Admin' || user.Role === 'Super Admin') return;

    const fp = _settings && _settings.FEATURE_PERMISSIONS;
    if (!fp || !fp.PropertyValue) return;

    let parsed;
    try {
        parsed = JSON.parse(fp.PropertyValue);
    } catch (e) {
        return;
    }

    const rolePerms = parsed && parsed[user.Role];
    if (!rolePerms || typeof rolePerms !== 'object') return;

    Object.keys(rolePerms).forEach(feature => {
        if (!OVERRIDABLE_FEATURES.has(feature)) return;
        applyLevel(can, cannot, rolePerms[feature], feature);
    });
}

function defineAbilitiesFor(user, _settings = {}) {
        return AbilityBuilder.define((can, cannot) => {
            if(user) {
                if (user.Role ==='Admin' || user.Role === 'Super Admin') {
                    //console.log('role admin or super admin');          
                    can('view', 'overdue_recall');   
                    can('view', 'unscheduled_treatment');
                    can('view', 'outstanding_claim');
                    can('view', 'broken_appointment'); 
                    can ('view', 'patient_balances'); 
                    can ('view', 'outstanding_preauths');
                    can('view', 'settings'); 
                    can('view', 'automations'); 
                    can('view', 'kpi');      
                    can('view', 'asap_list');

                    can('view', 'kanban');

                    can('view', 'myaccount');

                    can('view', 'huddle');
                    can('view', 'team-insights');
                    can('view', 'huddle');
                    can('view', 'tasks');
                    can('view', 'chat');
                    can('view', 'sms-conversations');
                    can('view', 'wiki');

                    // AI call history (Bot Conversations page). Admin-capable, NOT
                    // super-admin-only — site Admins see their own site, Super Admins
                    // any site (backend enforces ownership via employeeId + siteId).
                    // Future: when this goes live to sites, wrap in an AI feature flag
                    // (same pattern as the AI_FOLLOWUP_PAID_FOR gate used for AI Call
                    // campaigns above); not implemented now.
                    can('read', 'ai-call-history');

                    can('update', 'followupDate');
                    can('edit', 'followupNote');        

                    can ('update', 'employee');
                    can ('delete', 'employee');
                    can ('add', 'employee');
                    
                    can(['edit', 'delete'], 'Page');    // edit delete wikipage
                    can(['edit', 'delete'], 'forms');

                    can('delete', 'chatroom');
                    // Team Chat Export — admin-only feature. Used for departed-
                    // employee data access and HR/compliance records.
                    can('export', 'chatroom');

                } else if(user.Role === 'Manager') {
                    //console.log('role is manager');
                    //can('read', 'all', ['title', 'description']);  //rule per field
                    //can(['view_overdue_recall'], 'settings', {OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID : { PropertyValue : user.EmployeeID} }); 
                    can('view', 'overdue_recall');   
                    can('view', 'unscheduled_treatment');
                    can('view', 'outstanding_claim');
                    can('view', 'broken_appointment'); 
                    can ('view', 'patient_balances'); 
                    can ('view', 'outstanding_preauths');
                    can('view', 'asap_list');

                    can('view', 'myaccount');

                    can('view', 'kanban');

                    can('view', 'huddle');
                    can('view', 'team-insights');
                    can('view', 'huddle');
                    can('view', 'tasks');
                    can('view', 'chat');
                    can('view', 'conversations');
                    can('view', 'wiki');

                    can('view', 'settings'); 
                    can('view', 'automations'); 
                    can('view', 'kpi'); 
                    
                    can('update', 'followupDate');
                    can('edit', 'followupNote');  
                    
                    can ('add', 'employee');
                    can ('delete', 'employee');

                    can(['edit', 'delete'], 'Page'); // edit delete wikipage
                    can(['edit', 'delete'], 'forms');

                    can('delete', 'chatroom');
                } 
                
                // roleID = 4
                else if(user.Role === 'Employee') {
                    can('update', 'followupDate');
                    can('edit', 'followupNote');                    
                    can(['edit', 'delete'], 'Page', { CreatedByEmployeeID: user.EmployeeID });
                    
                    can('view', 'asap_list');

                    can('view', 'myaccount');

                    can('view', 'kanban');

                    can('view', 'huddle');
                    can('view', 'team-insights');
                    can('view', 'huddle');
                    can('view', 'tasks');
                    can('view', 'chat');
                    can('view', 'conversations');
                    can('view', 'wiki');
                }

                // roleID = 5
                else if(user.Role === 'Outsourced') {
                    //console.log('role is outsourced');
                    can('update', 'followupDate');
                    can('edit', 'followupNote'); 

                    can('view', 'kanban');

                    can('view', 'outstanding_claim');
                    can ('view', 'outstanding_preauths');
                    can ('view', 'patient_balances'); 
                    can('view', 'team-insights');
                    can('view', 'tasks');
                    can('view', 'chat');
                }

                // Campaigns: Super Admin always; other roles gated by CAMPAIGNS_PAID_FOR
                // and overridable per-role via FEATURE_PERMISSIONS (matches Forms/PracticePulse pattern).
                if (user.Role === 'Super Admin') {
                    can('view', 'campaigns');
                }
                if (_settings.CAMPAIGNS_PAID_FOR && _settings.CAMPAIGNS_PAID_FOR.PropertyValue === 'TRUE' && user.Role !== 'Outsourced') {
                    can('view', 'campaigns');
                }

                // AI Call campaigns: Super Admin always; other roles gated by AI_FOLLOWUP_PAID_FOR
                // (mirrors the CAMPAIGNS_PAID_FOR block above).
                if (user.Role === 'Super Admin') {
                    can('view', 'ai-call-campaigns');
                }
                if (_settings.AI_FOLLOWUP_PAID_FOR && _settings.AI_FOLLOWUP_PAID_FOR.PropertyValue === 'TRUE' && user.Role !== 'Outsourced') {
                    can('view', 'ai-call-campaigns');
                }

                // Insurance Verification: Super Admin always; other roles gated by
                // INSURANCE_VERIFICATION_ENABLED and overridable per-role via
                // FEATURE_PERMISSIONS (mirrors the CAMPAIGNS_PAID_FOR block above).
                //
                // ⛔ THIS ONE GATES SPENDING, NOT JUST VIEWING. Every "Verify Now" click
                // is a real, billed Stedi eligibility check (and TWO of them on a patient
                // with a secondary plan), so "who can open this page" is the same question
                // as "who can spend the practice's money." Before this subject existed the
                // dashboard was gated on the site flag OR Super Admin with NO role term at
                // all, which meant every user of every role at an enabled site could spend.
                //
                // Outsourced is excluded deliberately — external billing contractors get
                // read access to claims/balances elsewhere in this file, but they must not
                // be able to initiate vendor charges against the practice.
                //
                // Everyone else is granted by default ON PURPOSE: the front desk is exactly
                // who verifies insurance, so a blanket Admin-only lock would gut the
                // feature. The per-role FEATURE_PERMISSIONS override (MyAccount → Feature
                // Permissions) is the lever an office uses to narrow it.
                if (user.Role === 'Super Admin') {
                    can('view', 'insurance-verification');
                }
                if (_settings.INSURANCE_VERIFICATION_ENABLED && _settings.INSURANCE_VERIFICATION_ENABLED.PropertyValue === 'TRUE' && user.Role !== 'Outsourced') {
                    can('view', 'insurance-verification');
                }

                if(_settings.OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID && _settings.OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(user.EmployeeID)) {
                    //console.log(`matched overdue recall rule. EmployeeID: ${user.EmployeeID}, Setting Value: ${_settings.OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID.PropertyValue}`);
                    can ('view', 'overdue_recall');
                }

                if(_settings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID && _settings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(user.EmployeeID)) {
                    //console.log(`matched unscheduled treatment rule. EmployeeID: ${user.EmployeeID}, Setting Value: ${_settings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID.PropertyValue}`);
                    can ('view', 'unscheduled_treatment');
                }

                if(_settings.OUTSTANDING_CLAIM_RESPONSIBLE_EMPLOYEEID && _settings.OUTSTANDING_CLAIM_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(user.EmployeeID)) {
                    //console.log(`matched outstanding claim rule. EmployeeID: ${user.EmployeeID}, Setting Value: ${_settings.OUTSTANDING_CLAIM_RESPONSIBLE_EMPLOYEEID.PropertyValue}`);
                    can ('view', 'outstanding_claim');
                }

                if(_settings.BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID && _settings.BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(user.EmployeeID)) {
                    //console.log(`matched broken appointment rule. EmployeeID: ${user.EmployeeID}, Setting Value: ${_settings.BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID.PropertyValue}`);
                    can ('view', 'broken_appointment');
                }

                if(_settings.PATIENT_BALANCES_RESPONSIBLE_EMPLOYEEID && _settings.PATIENT_BALANCES_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(user.EmployeeID)) {
                    //console.log(`matched broken appointment rule. EmployeeID: ${user.EmployeeID}, Setting Value: ${_settings.BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID.PropertyValue}`);
                    can ('view', 'patient_balances');
                }

                if(_settings.OUTSTANDING_PREAUTHS_RESPONSIBLE_EMPLOYEEID && _settings.OUTSTANDING_PREAUTHS_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(user.EmployeeID)) {
                    //console.log(`matched broken appointment rule. EmployeeID: ${user.EmployeeID}, Setting Value: ${_settings.BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID.PropertyValue}`);
                    can ('view', 'outstanding_preauths');
                }

                // Admin / Super Admin always have full workflow access — matches the
                // Campaigns pattern above. Avoids the timing trap where rules are
                // computed before settings hydrate and WORKFLOW_ACTIVATED isn't visible.
                if (user.Role === 'Admin' || user.Role === 'Super Admin') {
                    can(['view', 'update', 'edit', 'add', 'delete'], 'workflow');
                }

                if(_settings.WORKFLOW_ACTIVATED && _settings.WORKFLOW_ACTIVATED.PropertyValue === 'TRUE' && user.Role !== 'Outsourced')
                    {
                        // Non-Outsourced roles get full edit access by default — matches the
                        // pre-guard behavior where the Edit pencil and Create button had no
                        // $can guard at all. An Admin can downgrade a specific role to "Read"
                        // via the MyAccount Feature Permissions matrix to make them view-only.
                        can(['view', 'update', 'edit', 'add'], 'workflow');
                    }

                // Conversations = a texting number OR WhatsApp — src/utils/siteCapability.js.
                // NOT isSmsEnabled: a WhatsApp-only office (outbound SMS off) still needs its inbox.
                if(canUseConversations(_settings) && user.Role !== 'Outsourced') {
                    can ('view', 'conversations');
                }

                if(_settings.FORMS_PAID_FOR && _settings.FORMS_PAID_FOR.PropertyValue === 'TRUE' && user.Role !== 'Outsourced') {
                    can ('view', 'forms');
                }

                // Reviews (Review Management Platform): Super Admin always; other
                // roles gated by REVIEWS_PAID_FOR (mirrors the FORMS_PAID_FOR block).
                if (user.Role === 'Super Admin') {
                    can('view', 'reviews');
                }
                if(_settings.REVIEWS_PAID_FOR && _settings.REVIEWS_PAID_FOR.PropertyValue === 'TRUE' && user.Role !== 'Outsourced') {
                    can ('view', 'reviews');
                }

                if(_settings.PRACTICE_PULSE_PAID_FOR && _settings.PRACTICE_PULSE_PAID_FOR.PropertyValue === 'TRUE' && user.Role !== 'Outsourced') {
                    can ('view', 'practice-pulse');
                }

                if(_settings.ONLINE_SCHEDULING_PAID_FOR &&
                   (_settings.ONLINE_SCHEDULING_PAID_FOR.PropertyValue === 'TRUE' || _settings.ONLINE_SCHEDULING_PAID_FOR.PropertyValue === 'true') &&
                   user.Role !== 'Outsourced') {
                    can ('view', 'online-appointments');
                }

                if(_settings.APPT_REMINDER_PAID_FOR && _settings.APPT_REMINDER_PAID_FOR.PropertyValue === 'TRUE' && user.Role !== 'Outsourced') {
                    can ('view', 'apt-reminder');
                }

                // Per-site FEATURE_PERMISSIONS overrides (set in MyAccount → Feature Permissions).
                // Applied LAST so cannot()/can() overrides any prior rule for the same subject.
                // Admin/Super Admin are never overridable.
                applyFeaturePermissionOverrides(can, cannot, user, _settings);
            }
        });
    }

// Export as default
export default defineAbilitiesFor;